import React, { useState } from 'react';

export const TermItem = ({
  term,
  allTerms,
  filter,
  facets,
  selectedFilters,
  onFilterChange,
  filterKey,
  depth = 0,
  groupId = null
}) => {
  const facetsForType = facets?.[`field_${filterKey}`];
  const facetInfo = facetsForType?.find(f => f.tid === term.tid);
  const count = facetInfo?.count ?? 0;
  const isChecked = filterKey === 'tags'
  ? (selectedFilters[filterKey]?.ungrouped?.includes(term.tid) || 
     Object.values(selectedFilters[filterKey]?.groups || {}).some(group => 
       group.includes(term.tid)
     ))
  : selectedFilters[filterKey]?.includes(term.tid) || false;

  // Get child terms using the children array
  const childTerms = term.children
    .map(childId => allTerms.find(t => t.tid === String(childId)))
    .filter(Boolean); // Remove any undefined values

  const hasChildren = childTerms.length > 0;
  const isVocabularyRoot = !term.ancestors || term.ancestors.length === 0;
  const isToggleOnly = isVocabularyRoot && !term.tid;
  const isCheckbox = !isToggleOnly;
  const isBothToggleAndCheckbox = hasChildren && !isToggleOnly;
  const [isExpanded, setIsExpanded] = useState(!isBothToggleAndCheckbox);

  return (
    <li className="term-item">
      <div
        className="flex items-center justify-between hover:bg-gray-50 p-1 rounded"
        style={{ paddingLeft: `${(depth - 1) * 1.5}rem` }}
      >
        <div className="heading">
          {isCheckbox && (
            <input
              type="checkbox"
              checked={isChecked}
              onChange={(e) => onFilterChange(filterKey, [term.tid], e.target.checked, groupId)}
              className="nsw-form__checkbox-input mr-2"
              id={`term-${term.tid}`}
            />
          )}

          <label
            htmlFor={isCheckbox ? `term-${term.tid}` : undefined}
            className={"flex-1 cursor-pointer"+(isCheckbox ? " nsw-form__checkbox-label" : "")}
          >
            <span>{term.name}</span>

            <span className="text-sm text-gray-500 ml-2"> ({count})</span>
          </label>

          {hasChildren && (
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="expand"
              aria-expanded={isExpanded}
              aria-label={`Toggle ${term.name}`}
            >
              <span className="material-icons nsw-material-icons" focusable="false" aria-hidden="true">{isExpanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</span>
            </button>
          )}
        </div>
      </div>

      {hasChildren && isExpanded && (
        <ul className="children-container">
          {childTerms.map(childTerm => (
            <TermItem
              key={childTerm.tid}
              term={childTerm}
              allTerms={allTerms}
              filter={filter}
              facets={facets}
              selectedFilters={selectedFilters}
              onFilterChange={onFilterChange}
              filterKey={filterKey}
              depth={depth + 1}
              groupId={groupId}
            />
          ))}
        </ul>
      )}
    </li>
  );
};
